module.exports = __webpack_public_path__ + "static/media/Kissen_60x60.d469590a.png";